import styled from "styled-components";

const SaleIOrderContent = styled.div`
  /* width: 100%; */
  height: 70vh;
  overflow: auto;

  & .ant-form-item {
    margin-bottom: 8px;
  }

  & .silent-error-form-item .ant-form-item-explain {
    display: none;
  }

  .list-wrap {
    /* width: 100%; */

    .list-item{
      border: 1px solid #b0aeae;
      border-radius: 6px;
      padding: 8px;
      margin-bottom: 8px;
    }
  }

`

export default SaleIOrderContent;
